import { render, staticRenderFns } from "./ServiceTile.vue?vue&type=template&id=0ffe47f6&"
import script from "./ServiceTile.vue?vue&type=script&lang=js&"
export * from "./ServiceTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports